import { BottomSheet } from '../../ui/BottomSheet';
import { Button } from '../../ui/Button';
import { FilterChip } from '../../ui/FilterChip';
import { SegmentedControl } from '../../ui/SegmentedControl';
import { EmptyState } from '../../ui/States';
import screen from '../screen.module.css';
import styles from './Dig.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  genreMode: boolean;
  /** The genres that have a shard, with their record counts (public/crate/genres.json) */
  index: [genre: string, records: number][];
  picked: readonly string[];
  onToggleGenre: (genre: string) => void;
  includeNew: boolean;
  onIncludeNew: (on: boolean) => void;
  canDig: boolean;
  onDig: () => void;
}

/**
 * Dig source (SPEC F6, Dig by genre): in Genres mode a multi-select of genres with record counts, and in both modes the
 * Include new recordings switch. A genre tap applies at once (2 taps to change genres); Dig here digs inside that tap.
 */
export function DigSourceSheet({ open, onClose, genreMode, index, picked, onToggleGenre, includeNew, onIncludeNew, canDig, onDig }: Props) {
  return (
    <BottomSheet open={open} title="Dig source" onClose={onClose}>
      <div className={styles.sourceSheet}>
        {genreMode ? (
          index.length === 0 ? (
            <EmptyState message="No genres yet. Build and deploy the crate." />
          ) : (
            <fieldset className={styles.genres}>
              <legend className="t-label">Genres</legend>
              <div className={styles.genreChips}>
                {index.map(([genre, n]) => (
                  <FilterChip key={genre} selected={picked.includes(genre)} onClick={() => onToggleGenre(genre)}>
                    {genre} <span className={styles.count}>{n.toLocaleString('en')}</span>
                  </FilterChip>
                ))}
              </div>
            </fieldset>
          )
        ) : (
          <p className={`t-body ${screen.sheetText}`}>Genres apply in Genres mode. In Style mode the style picks the channels.</p>
        )}
        <SegmentedControl<'on' | 'off'>
          label="Include new recordings"
          value={includeNew ? 'on' : 'off'}
          onChange={(v) => onIncludeNew(v === 'on')}
          segments={[{ value: 'off', label: 'Old records only' }, { value: 'on', label: 'Include new recordings' }]}
        />
        {genreMode && <Button variant="primary" disabled={!canDig} onClick={onDig}>Dig</Button>}
      </div>
    </BottomSheet>
  );
}
